// Fires an event to Google Analytics
// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const fireGoogleAnalyticsTag = (options) => {
    if (gtag) {
        const eventTags = {
            'event_category': options.category,
        };

        // "label" and "value" are optional attribute
        if (options.label) {
            eventTags['event_label'] = options.label;
        }
        if (options.value) {
            eventTags.value = options.value;
        }
        if (options.addDevice) {
            const deviceType = (document.querySelector('body').classList.contains('mobile')) ? 'Mobile' : 'Desktop';
            eventTags.label = deviceType;
        }

        gtag('event', options.action, eventTags);
    }
}
